import React from 'react';
import './AdrSection.css';

function AdrSection() {
  return (
    <section className="pm-scene-adr">
      <div className="pm-scene-inner">
        <div className="pm-adr-layout">
          <div className="pm-adr-text pm-reveal">
            <div className="pm-eyebrow" style={{ marginBottom: '18px' }}>Different from existing systems</div>
            <h2 className="pm-adr-headline">
              Not just <em>defect detection.</em><br />
              Expert review across the whole project.
            </h2>
            <p className="pm-adr-lede">
              Existing AI tools look at a single radiograph and ask "is there a defect?" Orbix asks the harder question: was the inspection set up correctly, executed by qualified personnel, documented to project spec, and is the imagery itself good enough to be trusted?
            </p>
            <div className="pm-adr-contrast">
              <div className="pm-adr-col pm-adr-them">
                <div className="pm-adr-lab">Most AI systems</div>
                <div className="pm-adr-what">Detection only</div>
                <div className="pm-adr-why">"Is there a defect in this image?" One question, one image, no project context.</div>
              </div>
              <div className="pm-adr-col pm-adr-us">
                <div className="pm-adr-lab">Orbix · AI Quality Team</div>
                <div className="pm-adr-what">Detection + Full Context</div>
                <div className="pm-adr-why">Defect detection plus the full audit a Level III would run: procedures, qualifications, technique, imagery quality, project-specific acceptance criteria.</div>
              </div>
            </div>
          </div>
          <div className="pm-adr-stage pm-reveal" style={{ '--reveal-delay': '200ms' }}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/img/prime/adr-screen.png`}
              alt="Orbix ADR — porosity detection alongside RT image review and audit queue"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AdrSection;
